import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { setIMURL, setLoginURL } from 'redux/auth/slice';

import { Routes } from './routes';

const LOGIN_API = 'https://api.demoyf.top';
const IM_API = 'https://messenger.api.peaxem.com';

export const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(setLoginURL(LOGIN_API));
    dispatch(setIMURL(IM_API));
    try {
      window.IMSocket = new WebSocket(`wss://${new URL(IM_API).host}`);
    } catch (_) { /* ignore */ }
  }, []);

  useEffect(() => {
    try {
      if (typeof Notification !== 'undefined') {
        Notification.requestPermission();
      }
    } catch (_) { /* ignore */ }
  }, []);

  return <Routes />;
};
